import { connect } from "react-redux";
import SalesforceExportHistoryDetail from "../components/AccountSetting/Salesforce/SalesforceExportHistory/SalesforceExportHistoryDetail";
import { goBack, push } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  errorMessage: state.sfdcExeSetting.errorMessage,
  shortMessage: state.sfdcExeSetting.shortMessage,
  successMessage: state.sfdcExeSetting.successMessage,
  isLoadingExportHistory: state.salesforce.isLoadingExportHistory,
  exportHistory: state.salesforce.exportHistory,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceExportHistoriesById(id) {
    dispatch(actions.getSalesforceExportHistoriesById(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceExportHistoryDetail);



// WEBPACK FOOTER //
// ./src/containers/SalesforceExportHistory.js